enum DeveloperApiTagTypes {
  Flag = 'Flag',
  Specification = 'Specification',
  SmileySurveySettings = 'SmileySurveySettings',
  ApplicationDetail = 'ApplicationDetail',
  OAuthClient = 'OAuthClient',
  OAuthApplications = 'OAuthApplications',
  AccessToken = 'AccessToken',
  ApiVersions = 'ApiVersions',
  PortalUser = 'PortalUser',
  SandboxTestAccount = 'SandboxTestAccount',
  AppSubmission = 'AppSubmission',
  QaAppSubmission = 'QaAppSubmission',
  ReviewerFeedback = 'ReviewerFeedback',
  ToS = 'ToS',
  SandboxAuthorization = 'SandboxAuthorization',
  DeveloperContacts = 'DeveloperContacts',
  RbacPermissions = 'RbacPermissions',
  AppSignature = 'AppSignature',
  WebhooksSubscriptions = 'WebhooksSubscriptions',
  WebhookEventTypes = 'WebhookEventTypes',
  WebhooksClient = 'WebhooksClient',
  ApiEvents = 'ApiEvents',
  WebhookEvents = 'WebhookEvents',
  RegisterApi = 'RegisterApi',

  ApplePayCertificate = 'ApplePayCertificate',
  ApplePayDomain = 'ApplePayDomain',

  // Preferences
  PreferenceScope = 'PreferenceScope',
  PreferenceGroup = 'PreferenceGroup',
}

export { DeveloperApiTagTypes };
